import { Api } from '@src/services/generated-api'

export const engineRoomApi = new Api({
  baseURL: BUILD_ENV.ENGINEROOM_API_URL || 'http://localhost:5050',
})
